/** Deterministic system ordering. Lower runs first. */
export const ORDER = {
  INPUT: 0,
  MISSION: 10,
  AI: 20,
  PLAYER: 30,
  COMBAT: 40,
  CROWD: 50,
  PHYSICS: 60,
  ANIM: 70,
  VFX: 80,
  CAMERA: 90,
  AUDIO: 95,
  WORLD: 97,
  RENDER: 98,
  UI: 100,
};
